import React, { useEffect, useState } from "react"
import { Input, message, Modal, Space, Tooltip } from "antd"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import PopupAction from "src/components/PopupAction"
import IconBase from "src/components/IconBase"
import WarehouseService from "src/services/WarehouseService"
import dayjs from "dayjs"
import ModalCreateOrder from "../Modal/ModalCreateOrder"
import OrderService from "src/services/OrderService"
import FilterOrder from "./FilterOrder"
import { reject } from "lodash"
import { data } from "jquery"
import { useNavigate } from "react-router-dom"
import ROUTER from "src/router"
const _dataSource = []

function ListOrder({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
  setExcelKeyword,
}) {
  const [dataSource, setDataSource] = useState(_dataSource)
  const [dataSelected, setDataSelected] = useState([])
  const [isModalAction, setIsModalAction] = useState({})
  const [openModalDetail, setOpenModalDetail] = useState(false)
  const [openModalEdit, setOpenModalEdit] = useState(false)
  const [editingRecord, setEditingRecord] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [rejectReason, setRejectReason] = useState("")
  const [rejectModalVisible, setRejectModalVisible] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")

  const navigate = useNavigate()
  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setParentFilter(filter)
    setExcelKeyword(keyword)
    try {
      const res = await WarehouseService.listOrder({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        const formatted = res?.success?.data.map((item, index) => {
          // lấy package_type lớn nhất
          const maxPackageType = item.history?.length
            ? Math.max(
                ...item.history.map(h =>
                  parseInt(Number(h.package?.package_type) || 28),
                ),
              )
            : 0

          // tính expected_date = approved_at + maxPackageType (số ngày)
          const expectedDate =
            item.approved_at && maxPackageType
              ? dayjs(item.approved_at).add(maxPackageType, "day").toISOString()
              : null
          return {
            ...item,
            key: item.ID || index,
            approved_person: item.approvedby?.fullname || "",
            total_amount: Number(item.total_amount).toLocaleString("en-US"),
            total_discount: Number(item.total_discount).toLocaleString("en-US"),
            expected_date: item.expected_delivery_date,
          }
        })
        const users = res?.success?.data || []
        const total = res?.success?.total || users.length
        const current = res.success?.current_page
        const perPage = res.success?.per_page

        setDataSource(formatted)
        setPagination({
          ...pagination,
          total: total,
        })
        setSummary({
          totalAccounts: total,
        })
        // setDataSource(
        //  ...res.success.data,
        //   // approved_by: res.success.data.approvedby.fullname,
        // )
      }
    } catch (err) {
      console.error("Lỗi gọi listOrder:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  // useEffect(() => {
  //   setPagination({
  //     ...pagination,
  //     current: 1,
  //   })
  // }, [filter])
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setDataSelected(selectedRows)
    },
  }

  const handleAction = (type, record) => {
    setIsModalAction({ type, record })

    if (type === "view") {
      setOpenModalDetail(true)
      setEditingRecord(record)
    }
    if (type === "edit") {
      setOpenModalEdit(true)
      setEditingRecord(record)
    }
    if (type === "received") {
      receivedProposal(record)
    }
    if (type === "approve") {
      approveProposal(record)
    }
    if (type === "reject") {
      setRejectModalVisible(true)
      setSelectedRecord(record)
    }
    if (type === "purchase") {
      purchaseOrder(record)
    }
    if (type === "reject_export") {
      setRejectModalVisible(true)
      setSelectedRecord(record)
    }
  }
  const ActionItem = ({ icon, label, onClick }) => (
    <div
      onClick={e => {
        e.stopPropagation()
        onClick()
      }}
      className="action-item"
    >
      <IconBase name={icon} />
      <span>{label}</span>
    </div>
  )
  const purchaseOrder = async record => {
    setLoading(true)
    try {
      const res = await OrderService.purchaseOrder(record.ID)
      if (res.message.includes("thành công")) {
        message.success(res.message || "Đã tiếp nhận đơn hàng thành công")
        navigate(ROUTER.ACCOUNT_LIST_REQUEST)
        setRefresh(prev => !prev)
      } else {
        message.error("Không thể duyệt đơn")
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "Lỗi không xác định từ máy chủ"
      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }
  const receivedProposal = async record => {
    setLoading(true)

    try {
      const res = await OrderService.receiveOrder(record.ID)
      if (res.message.includes("thành công")) {
        message.success(res.message || "Đã tiếp nhận đơn hàng thành công")
        setRefresh(prev => !prev)
      } else {
        message.error("Không thể duyệt đơn")
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || "Lỗi không xác định từ máy chủ"
      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }
  const approveProposal = async record => {
    setLoading(true)

    try {
      const res = await OrderService.approveOrder(record.ID)

      // Lấy thông báo từ API
      const apiMessage = res?.message?.message || res?.message || ""

      if (typeof apiMessage === "string" && apiMessage.includes("thành công")) {
        message.success(apiMessage)
        setRefresh(prev => !prev)
      } else {
        message.error(apiMessage || "Không thể duyệt đơn")
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message?.message +
          "(thiếu " +
          err?.response?.data?.message?.amount_missing +
          " VND)" ||
        err?.response?.data?.message ||
        "Lỗi không xác định từ máy chủ"

      message.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  const rejectProposal = async selectedRecord => {
    if (!rejectReason.trim())
      return message.warning("Vui lòng nhập lý do từ chối")

    setLoading(true)
    try {
      let res = {}
      if (selectedRecord.status === "2") {
        res = await WarehouseService.updateStatusRefuse(selectedRecord.ID, {
          note: rejectReason,
        })
      } else {
        res = await OrderService.rejectOrder(selectedRecord.ID, {
          note: rejectReason,
        })
      }
      if (res.message.includes("thành công")) {
        // Nếu phản hồi có message thành công
        message.success(res.message || "Từ chối đơn hàng thành công")
        // console.log(first)
        setRejectModalVisible(false)
        setRejectReason("")
        setRefresh(prev => !prev)
      } else {
        // Nếu không có message thành công, hiển thị thông báo lỗi
        message.error("Không thể từ chối đơn")
      }
    } catch (err) {
      message.error("Lỗi khi từ chối: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const column = [
    {
      title: "Mã đơn hàng",
      dataIndex: "export_code",
      align: "center",
    },
    {
      title: "Tên khách hàng",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    // {
    //   title: "Loại SIM",
    //   dataIndex: "sim_quantity",
    //   key: "sim_quantity",
    // },
    {
      title: "Số lượng SIM",
      dataIndex: "sim_quantity",
      key: "sim_quantity",
      align: "center",
    },

    // {
    //   title: "Đơn giá SIM",
    //   dataIndex: "sim_unit_price",
    //   key: "sim_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Dung lượng Data",
      dataIndex: "data_quantity",
      key: "data_quantity",
      align: "center",
    },
    // {
    //   title: "Đơn giá data",
    //   dataIndex: "data_unit_price",
    //   key: "data_unit_price",
    //   render: value => (value ? new Intl.NumberFormat().format(value) : "0"),
    // },
    {
      title: "Tổng tiền",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền sau chiết khấu",
      dataIndex: "total_discount",
      key: "total_discount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Người tạo",
      dataIndex: "createby",
      key: "createby",
      render: createby => createby?.fullname || "",
      align: "center",
    },
    {
      title: "Ngày tạo",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text, record) => {
        if (!text) return ""

        const createdAt = dayjs(text)
        const now = dayjs()
        const diffHours = now.diff(createdAt, "hour")

        // nếu trạng thái đã duyệt (status === "1") và quá 8h chưa tiếp nhận
        if (record.status === "1" && diffHours >= 8) {
          return (
            <Tooltip title="Chậm tiếp nhận">
              <span style={{ color: "red", fontWeight: "bold" }}>
                {createdAt.format("DD/MM/YYYY HH:mm")}
              </span>
            </Tooltip>
          )
        }

        return createdAt.format("DD/MM/YYYY HH:mm")
      },
    },
    {
      title: "Ngày dự kiến giao hàng",
      dataIndex: "expected_date",
      key: "expected_date",
      align: "center",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: "Người duyệt",
      dataIndex: "approved_person",
      key: "approved_person",
      align: "center",
    },
    //   {
    //     title: "Ngày duyệt",
    //     dataIndex: "approved_at",
    //     key: "approved_at",
    //   },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      key: "status",
      fixed: "right",
      render: text => {
        switch (text) {
          case "0":
            return (
              <span style={{ color: "orange", fontWeight: "bold" }}>
                Chờ duyệt
              </span>
            )
          // case "3":
          // case "2":
          case "1":
            return (
              <span style={{ color: "green", fontWeight: "bold" }}>
                Đã duyệt
              </span>
            )
          case "3":
            return (
              <span style={{ color: "#0288d1", fontWeight: "bold" }}>
                Hoàn thành mua
              </span>
            )
          case "4":
            return (
              <span style={{ color: "#6a1b9a", fontWeight: "bold" }}>
                Đã xuất kho
              </span>
            )
          case "2":
            return (
              <span style={{ color: "#1976d2", fontWeight: "bold" }}>
                Đã tiếp nhận
              </span>
            )
          case "5":
          case "6":
            return (
              <span style={{ color: "red", fontWeight: "bold" }}>Đã hủy</span>
            )
          default:
            return "Không xác định"
        }
      },
    },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const isPending = record.status === "0"
        const isApproved = record.status === "1"
        const isExported = record.status === "4"
        const isReceived = record.status === "2"
        const isPurchase = record.status === "3"
        return (
          //order.delete
          <PopupAction>
            {permissions.includes("order.detail") ? (
              <ActionItem
                icon="eye"
                label="Xem chi tiết"
                onClick={() => handleAction("view", record)}
              />
            ) : (
              <React.Fragment />
            )}

            {permissions.includes("order.update") && isPending ? (
              <ActionItem
                icon="edit"
                label="Sửa"
                onClick={() => handleAction("edit", record)}
              />
            ) : (
              <React.Fragment />
            )}

            {permissions.includes("order.received") &&
            isApproved &&
            !isPurchase &&
            !isExported ? (
              <ActionItem
                icon="approval"
                label="Tiếp nhận"
                onClick={() => handleAction("received", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("order.completedPurchase") && isReceived ? (
              <ActionItem
                icon="cart"
                label="Hoàn thành mua"
                onClick={() => handleAction("purchase", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {/* {isAproved ? (
              <ActionItem
                icon="approval"
                label="Tiếp nhận"
                onClick={() => handleAction("received", record)}
              />
            ) : (
              <React.Fragment />
            )} */}
            {permissions.includes("order.browse") && isPending ? (
              <ActionItem
                icon="approval"
                label="Duyệt"
                onClick={() => handleAction("approve", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("order.refuse") && isPending ? (
              <ActionItem
                icon="cancelApproval"
                label="Hủy đơn hàng"
                onClick={() => handleAction("reject", record)}
              />
            ) : (
              <React.Fragment />
            )}
            {permissions.includes("order.refuse") && isReceived ? (
              <ActionItem
                icon="cancelApproval"
                label="Hủy đơn hàng"
                onClick={() => handleAction("reject_export", record)}
              />
            ) : (
              <React.Fragment />
            )}
          </PopupAction>
        )
      },
    },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        {!!dataSelected.length && (
          <ButtonCircle
            style={{ marginRight: "10px", marginBottom: "10px" }}
            title="Xóa hàng đã chọn"
            iconName="delete-outline"
            onClick={() =>
              CB1({
                title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
                icon: "trashRed",
                okText: "Đồng ý",
                onOk: async close => {
                  // Logic to delete selected rows
                  close()
                },
              })
            }
          />
        )}
        <FilterOrder
          setFilter={setFilter}
          setKeyword={setKeyword}
          // tabStatus={tabStatus}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={column}
        dataSource={dataSource}
        showPagination
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {openModalDetail && (
        <ModalCreateOrder
          open={openModalDetail}
          onCancel={() => setOpenModalDetail(false)}
          onOk={() => {
            setOpenModalDetail(false)
          }}
          // data={dataSource.find(item => item.index === isModalAction.customerId)}
          editingRecord={editingRecord}
          isEditMode={true}
          refresh={setRefresh}
          onlyView={true}
        />
      )}
      {openModalEdit && (
        <ModalCreateOrder
          open={openModalEdit}
          onCancel={() => setOpenModalEdit(false)}
          onOk={() => {
            setOpenModalEdit(false)
          }}
          // data={dataSource.find(item => item.index === isModalAction.customerId)}
          editingRecord={editingRecord}
          isEditMode={true}
          refresh={setRefresh}
        />
      )}
      {rejectModalVisible && (
        <Modal
          title="Nhập lý do từ chối"
          open={rejectModalVisible}
          onOk={() => rejectProposal(selectedRecord)}
          onCancel={() => {
            setRejectModalVisible(false)
            setRejectReason("")
            setSelectedRecord(null)
          }}
          okText="Xác nhận từ chối"
          cancelText="Hủy"
          confirmLoading={loading}
        >
          <Input.TextArea
            rows={4}
            placeholder="Nhập lý do từ chối..."
            value={rejectReason}
            onChange={e => setRejectReason(e.target.value)}
          />
        </Modal>
      )}
    </div>
  )
}

export default ListOrder
